import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

type EnvRecord = Record<string, string | undefined>;

function getFromEnv(
  env: EnvRecord | undefined,
  key: string
): string | undefined {
  if (!env) {
    return;
  }
  const prefixes = ["", "VITE_", "NEXT_PUBLIC_", "NEXT_"] as const;
  for (const prefix of prefixes) {
    const value = env[`${prefix}${key}`];
    if (value) {
      return value;
    }
  }
  return;
}

export function resolveEnv(key: string): string | undefined {
  const nodeEnv =
    typeof process === "undefined"
      ? undefined
      : (process as unknown as { env?: EnvRecord }).env;
  const fromNode = getFromEnv(nodeEnv, key);
  if (fromNode) {
    return fromNode;
  }

  const viteEnv = (import.meta as unknown as { env?: EnvRecord }).env;
  return getFromEnv(viteEnv, key);
}
